// Typelizer digest b6a9424250018a6212f09b7d2c63d3f6
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /ideaboard */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/ideaboard', {}, options),
    method: 'get',
  }),

  /** POST /ideaboard/ideas */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/ideaboard/ideas', {}, options),
    method: 'post',
  }),
}
